import {Outlet, useLocation} from "react-router-dom";

const ReportsSetupRoute = () => {
    const location = useLocation();
    const routeWidths = [
        {path: '/add'},
    ];
    const currentWidth = routeWidths.find(route => location.pathname.includes(route.path)) || 'auto';

    return (
        <div className={"p-4"}>
            <div
                className={` h-[calc(100vh-96px)] overflow-y-auto 
                ${currentWidth === 'auto' ? '' : ''}`}
            >
                <Outlet/>
            </div>
        </div>
    )
}
export default ReportsSetupRoute;
